// Func = limiting Scope for this file
var lastScrollTop = 0;
//map array of click tags
var tagLocation = [];

var currentUrl = window.location.href;

(function () {

	// ADA "remove id secondary"
	document.querySelector("#signupContainer form .signup-btn ").removeAttribute('id')


	//third nav links to accessibility
	if (document.getElementById('third-nav')) {
		let allThird = document.getElementById('third-nav').getElementsByTagName('a');
		let allThirdLength = allThird.length;

		//let policiesItems = document.getElementsByClassName('js-h-item')

		for (let j = 0; j < allThirdLength; j++) {
			allThird[j].addEventListener('click', function (e) {
				let thisHref = this.getAttribute('href');
				if (thisHref.indexOf('#hover') > -1) {
					e.preventDefault();
					if (currentUrl.indexOf('info-policies') < 0) { // it is not in info policies page
						window.open(site_url + '/info-policies' + thisHref, "_self");
					} else {
						let allHoverImages = document.getElementById('hoverImages').getElementsByTagName('div');
						let allHoverLinks = document.getElementsByClassName('js-h-item');
						for (let h = 0; h < allHoverImages.length; h++) {
							allHoverImages[h].classList.remove('active');
							if (allHoverLinks[h].getAttribute('href') == thisHref) {
								allHoverLinks[h].classList.add('active');
							} else {
								allHoverLinks[h].classList.remove('active');
							}
						}
						document.getElementById(thisHref.split('#')[1]).classList.add('active');
						animateTo(thisHref.split('#')[1])
					}
				}
			})
		}
	}

	let jsSign = document.querySelector('.js-signup-cta')
	let signContainer = document.querySelector('.signup-container')
	const signClose = document.querySelector('.js-signup-close')
	if(jsSign){
		jsSign.addEventListener('click', function(){
			signContainer.classList.add('active')
		})
		signClose.addEventListener('click', function(e){
			e.preventDefault();
			signContainer.classList.remove('active')
		})
	}

	$(document).ready(function () {

		// if($(window).width() < 900 ){
		// 	$('.top-content__uvp').fadeIn();
		// }
		const iconsVideo = document.querySelectorAll('.controls-video > a');
		const video = document.getElementById('home-video');

		$('#home-video').on('ended',function(e){
			$(this).fadeOut();
			$('.top-content__uvp').fadeIn(2000);
			iconsVideo[0].classList.add('hidden');
			iconsVideo[1].classList.add('hidden');
			// $('.top-content__uvp').animate({left: '250px'});
		});
	
		if(iconsVideo && video){
			if(!video.ended){

				iconsVideo[0].addEventListener('click' , function(e){
					e.preventDefault();
					this.classList.add('hidden');
					iconsVideo[1].classList.remove('hidden');
					video.pause();
				});
	
				iconsVideo[1].addEventListener('click' , function(e){
					e.preventDefault();
					this.classList.add('hidden');
					iconsVideo[0].classList.remove('hidden');
					video.play();
				});

			}
		}

		var rellax = new Rellax('.illustration', { center: true });
		var rellax2 = new Rellax('.rellax', { center: true });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		//Map Desktop
		$(".js-pin").click(function () {

			let selfPin = $(this);
			// This will have the category
			var theID = $(this).data("tag");
			tagLocation.push(theID);

			if (theID == 'all') {
				$(".js-pin").removeClass('active');
				$('.pin').addClass('active');
				tagLocation = [];
				$(this).addClass('active');

			} else {
				$(".js-pin").each(function () {
					if ($(this).data("tag") === 'all') {
						$(this).removeClass('active');
					}
				});
				selfPin.toggleClass('active');

				$('.pin').removeClass('active');
				for (let i = 0; i < tagLocation.length; i++) {
					$('.pin[data-tag="' + tagLocation[i] + '"]').each(function () {
						if ($(this).hasClass('active')) {
							$(this).removeClass('active')
						} else {
							$(this).addClass('active')
						}
					});
				}
			}
		});



		$('.pin').on('click', function () {
			$(this).addClass('open');
			$(this).siblings().removeClass('open');
			var pinId = $(this).attr('id');
			$('.' + pinId).addClass('active');
			$('.' + pinId).siblings().removeClass('active');
		})

		$('.pin[data-slide]').click(function (e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('.map__info--text').slick('slickGoTo', slideno - 1);
		});

		if ($(window).width() < 960) {
			$('.map__info--text').slick();
		}



		// Hover elements
		// $('.js-h-item').hover(function (e) {
		// 	//$('html, body').animate({ scrollTop: $('.hover-items__container').offset().top-200 }, 'slow');
		// 	e.preventDefault();
		// 	$(this).siblings().removeClass('active');
		// 	$(this).addClass('active');
		// 	var href = $(this).attr('data-target');
		// 	$(href).addClass('active');
		// 	$(href).siblings().removeClass('active');
		// 	if (!$(this).hasClass('js-menu')) {
		// 		e.preventDefault();
		// 	}
		// });

		// HOVER ELEMENTS CHANGED FOR CLICK
		
		$('.js-h-item').on("click", function (e) {
			//$('html, body').animate({ scrollTop: $('.hover-items__container').offset().top-200 }, 'slow');
			e.preventDefault();
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
			var href = $(this).attr('data-target');
			$(href).addClass('active');
			$(href).siblings().removeClass('active');
			if (!$(this).hasClass('js-menu')) {
				e.preventDefault();
			}
		});

		// Learn more button
		$('.js-learnmore').click(function (e) {
			var href = $(this).attr('href');
			if (!$(this).hasClass('active')) {
				$(this).html('Read Less');
				$(this).addClass('active');
				$(href).slideDown(500, 'linear');
			} else {
				$(this).html('Read More');
				$(href).slideUp(500, 'linear');
				$(this).removeClass('active');
			}
			e.preventDefault();
		});

		//Aditional info rooms
		$('.js-more-details').on('click', function (e) {
			e.preventDefault();
			$(this).parent().parent().find('.additional-info').addClass('open');
		})

		$('.js-close-info').on('click', function (e) {
			e.preventDefault();
			$(this).parent().removeClass('open');
		})





		//Dots boundries
		function setBoundries(slick, state) {
			if (state === 'default') {
				slick.find('ul.slick-dots li').eq(4).addClass('n-small-1');
			}
		}

		// Slick Selector.
		var slickSlider = $('.dots-boundries');
		var maxDots = 4;
		var transformXIntervalNext = -51;
		var transformXIntervalPrev = 51;

		slickSlider.on('init', function (event, slick) {
			$(this).find('ul.slick-dots').wrap("<div class='slick-dots-container'></div>");
			$(this).find('ul.slick-dots li').each(function (index) {
				$(this).addClass('dot-index-' + index);
			});
			$(this).find('ul.slick-dots').css('transform', 'translateX(0)');
			setBoundries($(this), 'default');
		});

		var transformCount = 0;
		slickSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var totalCount = $(this).find('.slick-dots li').length;
			if (totalCount > maxDots) {
				if (nextSlide > currentSlide) {
					if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-small-1')) {
						if (!$(this).find('ul.slick-dots li:last-child').hasClass('n-small-1')) {
							transformCount = transformCount + transformXIntervalNext;
							$(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-small-1');
							var nextSlidePlusOne = nextSlide + 1;
							$(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small-1');
							$(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
							var pPointer = nextSlide - 3;
							var pPointerMinusOne = pPointer - 1;
							$(this).find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-small-1');
							$(this).find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
						}
					}
				}
				else {
					if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-small-1')) {
						if (!$(this).find('ul.slick-dots li:first-child').hasClass('p-small-1')) {
							transformCount = transformCount + transformXIntervalPrev;
							$(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-small-1');
							var nextSlidePlusOne = nextSlide - 1;
							$(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small-1');
							$(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
							var nPointer = currentSlide + 3;
							var nPointerMinusOne = nPointer - 1;
							$(this).find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
							$(this).find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small-1');
						}
					}
				}
			}
		});
		// if( document.querySelector('.dots-boundries') ) {
		// 		document.querySelector('.dots-boundries').slick({
		// 		slidesToShow: 1,
		// 		slidesToScroll: 1,
		// 		dots: true,
		// 		infinite: false
		// 	});
		// }

		



		if (currentUrl.indexOf('#hover') > -1) { //to accessibility links
			let thisHref = window.location.href.split('#')[1];
			if (document.getElementById('hoverImages')) {
				let allHoverImages = document.getElementById('hoverImages').getElementsByTagName('div');
				let allHoverLinks = document.getElementsByClassName('js-h-item');

				for (let h = 0; h < allHoverImages.length; h++) {
					allHoverImages[h].classList.remove('active');
				}
				for (let h = 0; h < allHoverLinks.length; h++) {
					if (allHoverLinks[h].getAttribute('href').split('#')[1] == thisHref) {
						allHoverLinks[h].classList.add('active');
					} else {
						allHoverLinks[h].classList.remove('active');
					}
				}
				document.getElementById(thisHref).classList.add('active');
				animateTo(thisHref)
			}
		} else {
			if (currentUrl.indexOf('#') > -1) {
				animateTo(currentUrl.split('#')[1])
			}
		}


	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	// Sign up form functionality

	let footerSignUp = document.querySelector('.footer__sign.content-signup');
	let signUpCta = document.querySelector('.js-signup-cta');
	
	footerSignUp.style.cursor = 'pointer';
	footerSignUp.addEventListener('click', () => simulateClick(signUpCta));

	function simulateClick(elem) {
		const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
		elem.dispatchEvent(event);
	}

}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

let menuTrigger = document.querySelectorAll('.js-menu');
let menuBlock = document.querySelector('.menu-block__nav');
let closeMenu = document.querySelector('.js-close');

// menuTrigger.addEventListener('click', function(){
// 	menuBlock.classList.add('open');
// })

menuTrigger.forEach(function (elem) {
	elem.addEventListener("click", function () {
		menuBlock.classList.add('open');
		menuBlock.classList.remove('closed');
		//this function does stuff
	});
});
closeMenu.addEventListener('click', function () {
	menuBlock.classList.add('closed');
	setTimeout(function () {
		menuBlock.classList.remove('open');
	}, 1500)
	//menuTrigger.classList.remove('active');
})